import React, { useContext } from 'react';
import Chart from 'react-google-charts';

import { Card, CardHeader } from '@material-ui/core';
import DashboardContext from 'src/pages/Private/Dashboard/context';
import { defaultChartOptions } from 'src/utils/charts';

const BenefitSolicitationsChart: React.FC = () => {
  const {
    chartsInfo: { benefitsSolicitations },
  } = useContext(DashboardContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader title="IFEPAF + IFBOLSAS" subheader="BENEFÍCIOS UTILIZADOS" />

      <Chart
        chartType="ColumnChart"
        data={benefitsSolicitations}
        options={defaultChartOptions}
      />
    </Card>
  );
};

export default BenefitSolicitationsChart;
